import React from 'react';
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import {
    Modal,
    Button,
    Card,
    CardHeader,
    CardBody,
    CardTitle,
    CardText,
} from 'reactstrap';
import { ThemeProps, RTLProps } from '@/shared/prop-types/ReducerProps';
import { Form } from 'react-final-form';
import axios from "axios";
import { useDispatch, flashSuccess, flashError } from "@/shared/components/flash"
import FieldUserStatus from '../../../../Users/components/FieldUserStatus';

const BulkStatusChangeModal = ({ organization, program, selectedRows, isOpen, toggle, theme, rtl, setTrigger }) => {
    const dispatch = useDispatch()

    const onSubmitChangeStatus = values => {
        let formData = {
            "program_id": program.id,
            "user_id": selectedRows.map((item) => item.id),
            "user_status_id": values.user_status_id.value
        }
        axios.put(`/organization/${organization.id}/program/${program.id}/bulk-status-change`, formData)
            .then((res) => {
                if (res.status == 200) {
                    setTrigger(Math.floor(Date.now() / 1000))
                    flashSuccess(dispatch, "Users Status updated successfully!")
                    toggle()
                }
            })
            .catch(error => {
                console.log(error.response.data);
                flashError(dispatch, error.response.data)
            })
    }

    return (
        <Modal className={`modal-action modal-md ${theme.className} ${rtl.direction}-support`} isOpen={isOpen} toggle={toggle}>
            <Card className='w-100'>
                <CardHeader tag="h3">
                    Change Status
                    <Button className='btn float-end' close onClick={toggle} />
                </CardHeader>
                <CardBody>
                    <CardTitle className='text-left'>Please select the status that you want to change to: </CardTitle>
                    <CardText className='text-left mb-2'>Selected Participants: </CardText>
                    <Form
                        onSubmit={onSubmitChangeStatus}
                        validate={(values) => { return true; }}
                        initialValues={{
                            user_status_id: { label: 'Active', value: '2' }
                        }}
                    >
                        {({ handleSubmit }) => (
                            <form className="form" onSubmit={handleSubmit}>
                                <div className='form__form-group label-mb-0'>
                                    {selectedRows.map((item) => (
                                        <li>{item.last_name}, {item.first_name}</li>
                                    ))}
                                </div>
                                <FieldUserStatus fieldType='select' />
                                <div className='row d-flex justify-content-end'>
                                    <Button className='btn-sm mr-2' color='primary' type='submit'>Change Status</Button>
                                    <Button className='btn-sm' color='outline-primary' onClick={toggle}>Cancel</Button>
                                </div>
                            </form>
                        )}
                    </Form>
                </CardBody>
            </Card>
        </Modal>
    )
}

BulkStatusChangeModal.propTypes = {
    theme: ThemeProps.isRequired,
    rtl: RTLProps.isRequired
};

export default withRouter(connect((state) => ({
    theme: state.theme,
    rtl: state.rtl,
    organization: state.organization
}))(BulkStatusChangeModal));